import { useContext } from 'react';

import { ScreenContext } from './ScreenContext';

export const useScreenDispatch = () => {
  return useContext(ScreenContext).dispatch;
};
